import { useMutation } from '@tanstack/react-query';
import { useFileUpload } from '../../contexts/FileUploadContext';
import FileUtil from '../../utils/FileUtil';
import trackingUtil from '../../utils/TrackingUtil';
import { useCreateTranscript } from './useCreateTranscript';

/**
 * Mutation to upload a file and create a transcript from it
 * @returns {Object} The mutation object
 */
export const useUploadSingleFile = () => {
  const { updateFile } = useFileUpload();
  const createTranscriptMutation = useCreateTranscript();

  return useMutation({
    mutationFn: async ({ projectId, file, fileId }) => {
      // Parse the file to extract body and name
      const response = await FileUtil.upload(file);
      
      // Create transcript using the generic mutation
      const result = await createTranscriptMutation.mutateAsync({
        projectId,
        name: response.name,
        body: response.body
      });
      
      const { transcript } = result;
      
      // Update file status to loaded
      updateFile(fileId, {
        loaded: true,
        transcript_id: transcript.id
      });
      
      trackingUtil.logEvent(`dropped_file_${response.fileType || 'unknown'}`);
      
      return { transcript, fileId, projectId };
    },
    
    onError: (error, variables) => {
      console.error('File upload failed:', error);
      
      // Update file status to error
      updateFile(variables.fileId, {
        loaded: false,
        error: error?.message || 'Upload failed'
      });
    }
  });
};